import { render, staticRenderFns } from "./LmDocumentModel.vue?vue&type=template&id=6bbdfe7e&"
import script from "./LmDocumentModel.vue?vue&type=script&lang=js&"
export * from "./LmDocumentModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports